<br> Lägg till / ändra avgift för {{institution.shortName}} {{institution.name}}
<br><br>
<form [formGroup]="feeform">
  <div class="row" style="max-width:700px;">
    <div class="col-md-3">
      <label for="year">
        År
      </label>
      <input type="text" class="form-control form-control-sm" style="max-width:120px;" id="year" formControlName="year" required />
    </div>
    <div class="col-md-3">
      <label for="fee">
        Belopp
      </label>
      <input type="text" class="form-control form-control-sm" style="max-width:120px;" id="fee" formControlName="fee" required />
    </div>
    <div class="col-md-6"><label>&nbsp;</label><button class="btn border" (click)="saveFee()" [disabled]="!feeform.valid">{{savelabel}}</button>
      <button class="btn border" [disabled]="!feeform.get('year').value" (click)="cancel()" style="margin-left:20px;">Avbryt</button>
    </div>
  </div>
</form>
<br>
<table>
  <th>År</th>
  <th>Avgift</th>
  <th>Perioder</th>
  <tr *ngFor="let fee of feelist">
    <td style="width: 50px;">{{fee.year}}</td>
    <td style="width: 50px;">{{fee.fee}}</td>
    <td style="width: 50px;">{{fee.paymentInterval}}</td>
    <td><a href="#" (click)="editFee(fee); $event.preventDefault();">Ändra</a></td>
  </tr>
</table>
